<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">我传阅的分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i> 
      </div>
    </div>
    <el-container   :style="conheight">
      <collapse-search>
      <div class="content_top_wrap">
        <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button size="small" type="primary" @click="search('find')">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>

        <!-- <el-input
          size="small"
          clearable
          style="width:240px;"
          placeholder="流程事项/工单号/流程名称"
          prefix-icon="el-icon-search"
          v-model="tableData"
          @keyup.enter.native="searchEnterFun"
        ></el-input>
        <div class="date_wrap">
          <a class="search_form_label">到达时间</a>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
        <el-row>
          <el-col :span="24">
            <el-button
              style="margin-left: 16px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh" style="margin-left: 16px"
              >重置</el-button
            >
          </el-col>
        </el-row> -->
      </div>
      </collapse-search>
      <el-main class="read_content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
           style="width: 100%;"
          header-cell-class-name="todo-header-row"
          :row-class-name="tableRowClass"
          size="medium"
          height="100%"
          v-loading.fullscreen.lock="fullscreenLoading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column type="index" width="50" align="center" label="序号"></el-table-column> -->
          <el-table-column
            prop="workOrderNo"
            width="120"
            align="left"
            label="工单号"
            sortable
          ></el-table-column>
          <el-table-column label="流程事项">
            <template slot-scope="scope">
              <span class="todo-subject" @click="handleRowClick(scope.row)">{{
                scope.row.subject
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="流程名称"
            align="left"
            width="85"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procDefName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="任务名称"
            align="left"
            width="160"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="到达时间"
            align="left"
            sortable
            width="160"
          ></el-table-column>
          <el-table-column
            prop="assigneeName"
            label="被传阅人"
            align="left"
            width="120"
          ></el-table-column>
          <el-table-column width="80" align="left" label="阅读状态">
            <template slot-scope="scope">
              <el-badge v-if="scope.row.isRead != '1'" is-dot></el-badge>
              <el-badge v-else size="small" is-dot  type="info"></el-badge>
              <el-badge v-if="scope.row.isRead !='1'" size="small" >待阅</el-badge>
              <el-badge v-else size="small">已阅</el-badge>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
            align="left"
          >
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.topnum==0" @click="isTop('',scope.row)" style="font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #1890FF;cursor: pointer;">置顶</div>

              <div v-else @click="isTop('',scope.row)" style="font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;color:#1890FF;cursor: pointer;">取消置顶</div> -->
              <eipTop 
                @search="search"
                :currentRow="scope.row"
                topType=2
                showItem="one">
              </eipTop>
            </template>
          </el-table-column>
          <!-- <el-table-column width="75" align="left" label="撤回状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isRevoke == 0" size="small"
                >未撤回</el-tag
              >
              <el-tag v-if="scope.row.isRevoke == 1" type="danger" size="small"
                >已撤回</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column width="70" align="left" label="操作">
            <template slot-scope="scope">
              <a class="chehui" v-if="scope.row.isRevoke == 0"  @click="delBpmTaskNoticeById(scope.row)">撤回</a>
            </template>
          </el-table-column> -->
        </el-table>
      </el-main>
      <el-footer height="45px;line-height: 45px;">
        <el-row>
          <eipTop style="display:initial" @search="search" :topList="topList" topType=2 showItem="many"></eipTop>
          <div style="float: right;display:initial">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process.js";
import searchForm from "@/components/common/searchForm.vue";
import eipTop from "@/components/eipControl/EipTop"

export default {
  name: "myRead",
  components: {
    FlowTree,
    searchForm,
    eipTop
  },
  props: {
    defKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      asideShow: false,
      tableData: "",
      date: "",
      currentTree: "",
      fullscreenLoading: true,
      conheight:{ height:'' },
      searchOptions: [
        {
          property: "bpm_pro_inst.subject_",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "bpm_pro_inst.work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        },
        {
          label: "状态",
          property: "bpm_task_notice.is_read_",
          operation: "EQUAL",
          type: "select",
          placeholder: "请选择状态",
          options: [
          {
          value: "",
          label: "全部",
          },
          {
            value: "0",
            label: "待阅",
          },
          {
            value: "1",
            label: "已阅",
          }
            ]
          }
      ],
      topList:[]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total
  }),
  methods: {
    //批量勾选
    handleSelectionChange(val) {
      this.arrlen = val.length;
      this.topList = [];
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          let topRow = {gdh:val[i].workOrderNo,topnum:val[i].topnum?val[i].topnum:0};
          this.topList.push(topRow);
        }
      }
    },
     getHeight(){
      this.conheight.height = window.innerHeight - 112 + "px";
    },
    //根据ID主键ID删除传阅任务
    delBpmTaskNoticeById(row) {
      this.$confirm("确认撤回此任务?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$store
          .dispatch("storeProcess/delBpmTaskNoticeById", row.id)
          .then(() => {
            this.search();
          });
      });
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getMyNoticeReadList", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });


      // this.openFullScreen();
      // if (str == "find") {
      //   this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      // }
      // let querys = []; //查询条件
      // let queryFilter = {};
      // let pageBean = { pageBean: this.pagination };
      // let group = "main1"; //判断条件
      // if (this.tableData) {
      //   querys = [
      //     {
      //       property: "bpm_pro_inst.subject_",
      //       value: this.tableData,
      //       group: "main1",
      //       operation: "LIKE",
      //       relation: "OR",
      //     },

      //     {
      //       property: "bpm_pro_inst.proc_def_name_",
      //       value: this.tableData,
      //       group: "main1",
      //       operation: "LIKE",
      //       relation: "OR",
      //     },
      //     {
      //       property: "bpm_pro_inst.work_order_no",
      //       value: this.tableData,
      //       group: "main1",
      //       operation: "LIKE",
      //       relation : "OR"
      //     }
      //   ];
      // }

      // if (this.currentTree) {
      //   querys.push({
      //     property: "bpm_pro_inst.type_id_",
      //     value: this.currentTree,
      //     group: "typeId",
      //     operation: "IN",
      //     relation: "AND",
      //   });
      // }

      // if (this.date) {
      //   let beginDate = utils.formatDate(this.date[0].getTime()); //开始时间
      //   let endDate = utils.formatDate(this.date[1].getTime()); //结束时间
      //   querys.push({
      //     property: "bpm_task_notice.create_time_",
      //     value: [beginDate, endDate],
      //     group: "time",
      //     operation: "BETWEEN",
      //     relation: "AND",
      //   });
      // }
      // if (this.defKey) {
      //   querys.push({
      //     property: "bpm_pro_inst.proc_def_key_",
      //     value: this.defKey,
      //     operation: "EQUAL",
      //     relation: "AND",
      //   });
      // }
      // queryFilter = { pageBean: this.pagination, querys };
      // this.$store
      //   .dispatch("storeProcess/getMyNoticeReadList", queryFilter)
      //   .then(() => {
      //     this.fullscreenLoading = false;
      //   });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      /*this.$router.push(
        "/myRead/" + row.procInstId + "/" + row.id + "/myRead"
      );*/
      let url = window.context.front;
      let token = this.$store.state.login.currentUser.token;
      url += "/myRead/" + row.procInstId + "/" + row.id + "/myRead";
      url += "?token=" + token;
      window.open(
        url,
        "_blank",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 70)
      );
    },
    //子组件传值父组件(待办分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let pageBean = { pageBean: this.pagination };
        this.$store
          .dispatch("storeProcess/getMyNoticeReadList", pageBean)
          .then(() => {
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      return process.getMyNoticeReadCount({});
    },
    tableRowClass(rows){
      if(rows.row.topnum){
        return 'row-class';
      }
      return 'todo-row';
    }
  },
  created() {
    //页面高度设置
    window.addEventListener('resize', this.getHeight);
    this.getHeight();

    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "bpm_pro_inst.proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND",
      });
    }
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys,
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getMyNoticeReadList", pageBean)
      .then(() => {
        //页面加载调用tudo.js里面的分页方法
        this.fullscreenLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

.el-table /deep/ tr.row-class{
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
  background-color: #eee;
}

/deep/ .el-badge__content.is-dot{
  margin-top: 10px !important;
  margin-right: 8px !important;
  width: 6px !important;
  height: 6px !important;
}

  
/deep/ .el-badge{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
}

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}


/deep/ .chehui{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #1890FF !important;
}

.list_main_content {
  padding: 0;
}

/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 

/deep/.el-table th{
  height: 48px;
  background: #F0F2F5;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
}



/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
   background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    } 
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}

.el-row {
  margin-bottom: 10px;
}

/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top:  0px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
/deep/.el-tag {
  padding-left: 3px;
  padding-right: 3px;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}

.el-header {
  border-bottom: 1.5px solid #ededed;
}

.todo-subject {
  cursor: pointer;
}

.todo-subject {
  color: $--theme-color;
}

.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}
/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.read_content {
  padding: 0px;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 0px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
</style>
